export default "__VITE_ASSET__C2v5hAnR__"